export enum UserSignupStatus {
  PENDING_INVITATION = -1,
  REJECTED = 0,
  ACCEPTED = 1,
  PENDING = 2,
}
